import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ArrowDownwardRounded from "@mui/icons-material/ArrowDownwardRounded";
import WhatsApp from "@mui/icons-material/WhatsApp";
import Card from "../Card/Card";

import "./MainLayout.css";

import { GlobalConsumer } from "../../context/Consumer";
import { PhoneNumberWA, PhoneNumberCall } from "../../context/Context";

const MainLayout = (props) => {
  const featuredProduct = props.product[0];
  const whatsappUrl = `https://wa.me/${PhoneNumberWA.replace(
    "+",
    ""
  )}?text=${encodeURIComponent(
    "Halo Jaya Sukses Pratama, saya ingin berkonsultasi mengenai mesin packaging."
  )}`;

  return (
    <Box component="main" className="page-shell">
      <Box component="section" className="hero-section">
        <Container maxWidth="lg">
          <Grid container spacing={{ xs: 5, md: 8 }} alignItems="center">
            <Grid item xs={12} md={7}>
              <Typography component="p" className="hero-eyebrow">
                Mesin packaging buatan Indonesia
              </Typography>
              <Typography component="h1" className="hero-title">
                Kemasan rapi dimulai dari mesin yang tepat.
              </Typography>
              <Typography component="p" className="hero-description">
                Pilihan mesin pengemas otomatis untuk produk powder, granule,
                dan liquid—lengkap dengan spesifikasi yang mudah dibandingkan.
              </Typography>

              <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
                <Button
                  href="#products"
                  variant="contained"
                  color="secondary"
                  endIcon={<ArrowDownwardRounded />}
                >
                  Lihat pilihan mesin
                </Button>
                <Button
                  href={whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                  variant="outlined"
                  className="hero-whatsapp-button"
                  startIcon={<WhatsApp />}
                >
                  Konsultasi kebutuhan
                </Button>
              </Stack>

              <Box className="hero-facts" aria-label="Ringkasan katalog">
                <div>
                  <strong>{props.product.length}</strong>
                  <span>varian mesin</span>
                </div>
                <div>
                  <strong>3SS · CS · 4SS</strong>
                  <span>pilihan tipe seal</span>
                </div>
                <div>
                  <strong>Sidoarjo</strong>
                  <span>lokasi workshop</span>
                </div>
              </Box>
            </Grid>

            <Grid item xs={12} md={5}>
              <Box className="hero-product-visual">
                <span className="hero-product-index">01</span>
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/${featuredProduct.id}.png`}
                  alt={`Mesin ${featuredProduct.nameMachine}`}
                />
                <Box className="hero-product-caption">
                  <span>Pilihan mesin</span>
                  <strong>{featuredProduct.nameMachine}</strong>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Box component="section" id="products" className="catalog-section">
        <Container maxWidth="lg">
          <Box className="section-heading">
            <Box>
              <Typography component="p" className="section-eyebrow">
                Katalog mesin
              </Typography>
              <Typography component="h2" className="section-title">
                Temukan mesin sesuai produk Anda
              </Typography>
            </Box>
          </Box>

          <Grid container spacing={{ xs: 2.5, md: 3 }}>
            {props.product.map((data) => (
              <Grid key={data.id} item xs={12} sm={6} lg={4}>
                <Card value={data} />
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      <Box component="section" className="contact-section">
        <Container maxWidth="lg">
          <Box className="contact-panel">
            <Box>
              <Typography component="p" className="contact-kicker">
                Belum yakin memilih model?
              </Typography>
              <Typography component="h2" className="contact-title">
                Ceritakan produk dan target kemasan Anda.
              </Typography>
              <Typography component="p" className="contact-copy">
                Tim kami siap membantu mencocokkan kapasitas, jenis filler,
                dan tipe seal yang dibutuhkan.
              </Typography>
            </Box>
            <Stack
              direction={{ xs: "column", sm: "row", md: "column" }}
              spacing={1.5}
              className="contact-actions"
            >
              <Button
                href={whatsappUrl}
                target="_blank"
                rel="noreferrer"
                variant="contained"
                color="success"
                startIcon={<WhatsApp />}
              >
                Chat via WhatsApp
              </Button>
              <Button
                href={`tel:${PhoneNumberCall}`}
                variant="outlined"
                className="contact-call-button"
              >
                Telepon {PhoneNumberCall}
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>

      <Box component="footer" className="site-footer">
        <Container maxWidth="lg" className="footer-inner">
          <Typography component="p">
            © {new Date().getFullYear()} Jaya Sukses Pratama Machinery
          </Typography>
          <Typography component="p">
            Semampir RT 06/RW 03, Sedati, Sidoarjo, Jawa Timur 61253
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default GlobalConsumer(MainLayout);
